export default __webpack_public_path__ + "static/media/nav-account-white.b6bbf9d2.svg";